import React from 'react';
import PropTypes from 'prop-types';
import useSunburstChart from './useSunburstChart';

export default function SunburstChart({ movie, includeScenes, metric, onSelect }) {
  const chartRef = useSunburstChart({ movie, includeScenes, metric, onSelect, animateAct1:true });
  return <div ref={chartRef} style={{height: '100vh', width: '100%'}}/>;
}
SunburstChart.propTypes = {
  movie: PropTypes.object.isRequired,
  includeScenes: PropTypes.bool.isRequired,
  metric:        PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
};